module.exports = __webpack_public_path__ + "static/large-logo-d387448a083422a1d569778840c1bfc5.svg";